import { render } from "./PolicySection.vue?vue&type=template&id=5b6d5f3c&scoped=true"
import script from "./PolicySection.vue?vue&type=script&lang=js"
export * from "./PolicySection.vue?vue&type=script&lang=js"

import "./PolicySection.vue?vue&type=style&index=0&id=5b6d5f3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6d5f3c"]])

export default __exports__